<template>
  <div>
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>港口名称：</p>
        <el-input v-model="portIpt" size="mini" style="width:150px" placeholder="请输入供应商"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>作业编号：</p>
        <el-input v-model="waybillIpt" size="mini" style="width:150px" placeholder="请输入运单编号"/>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>批次号：</p>
        <el-input v-model="batchIpt" size="mini" style="width:150px" placeholder="请输入批次号"/>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>底盘号：</p>
        <el-input v-model="chassisIpt" size="mini" style="width:150px" placeholder="请输入底盘号"/>
      </div>
      <div class="navContainer" style="width: 420px">
        <p>作业日期：</p>
        <el-date-picker
          v-model="dateIpt"
          type="daterange"
          size="mini"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>作业类型：</p>
        <el-select v-model="typeIpt" filterable size="mini" style="width:150px" placeholder="请选择费用类型">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 270px">
        <p>是否生成对账单：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择费用类型">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">生成对账单</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <div class="tableContainerNav">
          <span @click="importClick">导入生成对账单</span>
          <span @click="exportClick">导出数据</span>
        </div>
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="30"/>
          <el-table-column prop="name" label="港口名称" align="center"/>
          <el-table-column prop="waybill" label="作业编号" align="center"/>
          <el-table-column prop="batch" label="批次号" align="center"/>
          <el-table-column prop="chassis" label="底盘号" align="center"/>
          <el-table-column prop="brand" label="品牌" align="center"/>
          <el-table-column prop="type" label="型号" align="center"/>
          <el-table-column prop="planDate" label="作业日期" align="center"/>
          <el-table-column prop="payment" label="费用类型" align="center"/>
          <el-table-column prop="cost" label="含税费用" align="center"/>
          <el-table-column prop="afterCost" label="含税费用" align="center"/>
          <el-table-column prop="statement" label="是否生成对账单" align="center"/>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='1050px' center :close-on-click-modal="false" top="10vh">
      <div class="dialogContainer">
        <div class="dialogContainerTitle">
          <div class="dialogContainerTitleInput">
            <span>标题：</span>
            <el-input v-model="addData.title" size="mini" style="width:160px" placeholder="请输入对账单标题" />
          </div>
          <div class="dialogContainerTitleBtn">
            <el-button style="width: 54px;height: 26px;" size="mini" type="primary" @click="confirmBtn">确认</el-button>
            <el-button size="mini" class="resetBtn" @click="dialogVisible=false">取消</el-button>
          </div>
        </div>
        <span style="margin-bottom: 10px;">合计含税费用：{{addData.price1?addData.price1+'元':'-'}}</span>
        <span style="margin-bottom: 15px;">合计税后费用：{{addData.price2?addData.price2+'元':'-'}}</span>
        <div class="instructions">
          <div class="instructionsTitle">
            <div class="line"/>
            <span>费用说明</span>
          </div>
          <div class="instructionsTable">
            <el-table :data="addData.payTable" border :row-class-name="tableRowClassName">
              <el-table-column label="序号" align="center" width="50px">
                <div slot-scope="scope">{{scope.$index+1}}</div>
              </el-table-column>
              <el-table-column prop="name" label="港口名称" align="center"/>
              <el-table-column prop="waybill" label="作业编号" align="center"/>
              <el-table-column prop="batch" label="批次号" align="center"/>
              <el-table-column prop="chassis" label="底盘号" align="center"/>
              <el-table-column prop="brand" label="品牌" align="center"/>
              <el-table-column prop="type" label="型号" align="center"/>
              <el-table-column prop="date" label="作业日期" align="center"/>
              <el-table-column prop="payType" label="费用类型" align="center"/>
              <el-table-column prop="price" label="含税费用" align="center"/>
              <el-table-column prop="afterPrice" label="税后费用" align="center"/>
              <el-table-column v-if="dialogTitle==='导入生成对账单'" prop="remark" label="说明" align="center"/>
              <el-table-column label="操作" align="center" width="45px">
                <div slot-scope="scope" style="display:flex;align-items:center;justify-content:center" v-if="addData.payTable.length>1">
                  <i class="el-icon-error" @click="removeClick(scope.$index,1)" style="cursor: pointer;font-size: 16px"/>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="instructions" v-if="dialogTitle==='导入生成对账单'">
          <div class="instructionsTitle">
            <div class="line"/>
            <span>未生成车辆</span>
          </div>
          <div class="instructionsTable">
            <el-table :data="addData.carTable" border :row-class-name="tableRowClassName">
              <el-table-column label="序号" align="center" width="50px">
                <div slot-scope="scope">{{scope.$index+1}}</div>
              </el-table-column>
              <el-table-column prop="name" label="港口名称" align="center"/>
              <el-table-column prop="batch" label="批次号" align="center"/>
              <el-table-column prop="chassis" label="底盘号" align="center"/>
              <el-table-column prop="brand" label="品牌" align="center"/>
              <el-table-column prop="type" label="型号" align="center"/>
              <el-table-column prop="priceType" label="费用类型" align="center"/>
              <el-table-column prop="price" label="含税费用" align="center"/>
              <el-table-column prop="afterPrice" label="税后费用" align="center"/>
              <el-table-column prop="remark" label="说明" align="center"/>
              <el-table-column label="操作" align="center">
                <div slot-scope="scope" style="display:flex;align-items:center;justify-content:center">
                  <el-button v-if="scope.row.remark==='暂未选择'" size="mini" type="primary" @click="addBtn1">添加</el-button>
                  <span v-else>-</span>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="instructions">
          <div class="instructionsTitle">
            <div class="line"/>
            <span>其它费用</span>
          </div>
          <div class="instructionsTable">
            <div class="instructionsTableNav">
              <span @click="tableAddClick">添加</span>
            </div>
            <el-table :data="addData.payTable2" border>
              <el-table-column label="序号" align="center" width="50px">
                <div slot-scope="scope">{{scope.$index+1}}</div>
              </el-table-column>
              <el-table-column prop="number" label="费用编号" align="center"/>
              <el-table-column prop="name" label="港口名称" align="center"/>
              <el-table-column prop="type" label="费用类型" align="center"/>
              <el-table-column prop="remark" label="费用说明" align="center"/>
              <el-table-column prop="time" label="费用时间" align="center"/>
              <el-table-column prop="price" label="费用金额" align="center"/>
              <el-table-column label="操作" align="center">
                <div slot-scope="scope" style="display:flex;align-items:center;justify-content:center" v-if="addData.payTable2.length>1">
                  <i class="el-icon-error" @click="removeClick(scope.$index,2)" style="cursor: pointer;font-size: 16px"/>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="添加其它费用" :visible.sync="addPriceVisible" width='750px' center :close-on-click-modal="false">
      <div class="priceContainer">
        <div class="priceContainerNav">
          <div class="priceContainerNavItem" style="width:230px;">
            <p>费用编号：</p>
            <el-input v-model="priceData.number" size="mini" style="width:150px" placeholder="请输入费用编号"/>
          </div>
          <div class="priceContainerNavItem" style="width:230px;">
            <p>港口名称：</p>
            <el-input v-model="priceData.name" size="mini" style="width:150px" placeholder="请输入供应商"/>
          </div>
          <div class="priceContainerNavItem" style="width:230px;">
            <p>费用类型：</p>
            <el-select v-model="priceData.type" filterable size="mini" style="width:150px" placeholder="请选择费用类型">
              <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value"/>
            </el-select>
          </div>
          <div class="priceContainerNavItem" style="width:470px;">
            <p>费用时间：</p>
            <el-date-picker
              v-model="priceData.time"
              type="datetimerange"
              size="mini"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"/>
          </div>
          <div class="priceContainerNavBtn">
            <el-button size="mini" class="searchBtn" @click="searchBtn2">查询</el-button>
            <el-button size="mini" class="resetBtn" @click="resetBtn2">重置</el-button>
          </div>
        </div>
        <div class="priceContainerTable">
          <el-table :data="priceData.table" border @selection-change="handleSelectionChange2">
            <el-table-column type="selection" width="34"/>
            <el-table-column prop="number" label="费用编号" align="center"/>
            <el-table-column prop="name" label="港口名称" align="center"/>
            <el-table-column prop="type" label="费用类型" align="center"/>
            <el-table-column prop="remark" label="费用说明" align="center"/>
            <el-table-column prop="time" label="费用时间" align="center"/>
            <el-table-column prop="price" label="费用金额" align="center"/>
          </el-table>
        </div>
        <div class="paginationContainer">
          <span>共{{total}}条</span>
          <el-pagination
            background
            :page-sizes="[5, 10]"
            layout="sizes,prev, pager, next,jumper"
            :total="priceTotal"
            @size-change="contractSizeChange1"
            @current-change="contractCurrentChange1"
            @prev-click="contractCurrentChange1"
            @next-click="contractCurrentChange1"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
  },

  data() {
    return {
      portIpt:'',
      waybillIpt:'',
      batchIpt:'',
      chassisIpt:'',
      dateIpt:'',
      typeIpt:'',
      stateIpt:'',
      typeOption:[
        {value:'',label:'全部',},
        {value:'托运',label:'托运',},
        {value:'质损',label:'质损',},
        {value:'塔电',label:'塔电',},
      ],
      stateOption:[
        {value:'',label:'全部',},
        {value:1,label:'是',},
        {value:0,label:'否',},
      ],
      tableLoad:false,
      TableDatas:[
        {name:'供应商1',waybill:'BH2012151',batch:'PC201210112',chassis:'DP215411',brand:'品牌1',type:'型号1',planDate:'2021-10-8',payment:'托运',cost:'300',afterCost:'300',statement:'否',},
        {name:'供应商1',waybill:'BH2012151',batch:'PC201210112',chassis:'DP215411',brand:'品牌1',type:'型号1',planDate:'2021-10-8',payment:'质损',cost:'200',afterCost:'300',statement:'否',},
        {name:'供应商1',waybill:'BH2012151',batch:'PC201210112',chassis:'DP215411',brand:'品牌1',type:'型号1',planDate:'2021-10-8',payment:'塔电',cost:'250',afterCost:'300',statement:'是',},
      ],
      page:1,
      size:10,
      total:0,
      pricePage:1,
      priceSize:5,
      priceTotal:0,
      dialogTitle:'',
      dialogVisible:false,
      addData:{
        title:'',
        price1:'',
        price2:'',
        payTable:[],
        payTable2:[],
      },
      addPriceVisible:false,
      priceData:{
        number:'',
        name:'',
        type:'',
        time:'',
        table:[],
      },
    };
  },
  methods: {
    confirmBtn(){
      this.addData={
        ...this.addData,
        title:this.addData.title.trim(),
      }
      if(!this.addData.title) return this.$message.warning('账单标题不能为空！');
      this.dialogVisible=false;
    },
    searchBtn2(){
      this.priceData.table = [
        {number:'000000', name:'港口1', type:'类型1',remark:'说明1',time:'2021-10-18 19:32:37',price:'10',},
        {number:'000000', name:'港口2', type:'类型1',remark:'说明1',time:'2021-10-18 19:32:37',price:'20',},
      ];
    },
    resetBtn2(){
      this.priceData={
        ...this.priceData,
        number:'',
        name:'',
        type:'',
        time:'',
      };
    },
    resetBtn(){
      this.portIpt='';
      this.waybillIpt='';
      this.batchIpt='';
      this.chassisIpt='';
      this.dateIpt='';
      this.typeIpt='';
      this.stateIpt='';
    },
    addBtn1(){},
    contractSizeChange(sizes){
      this.size=sizes;
    },
    contractCurrentChange(page){
      this.page=page;
    },
    contractSizeChange1(sizes){
      this.priceSize=sizes;
    },
    contractCurrentChange1(page){
      this.pricePage=page;
    },
    searchBtn(){
      this.page = 1
    },
    addBtn(){
      this.dialogVisible=true;
      this.dialogTitle='生成对账单';
      this.addData={
        title:'',
        price1:'',
        price2:'100',
        payTable:[
          {name:'委托商1',waybill:'BH2011541',batch:'PC2154112',chassis:'DP2121201',brand:'品牌1',type:'型号',date:'2021-9-12',payType:'托运',price:'60',afterPrice:'60',},
          {name:'委托商1',waybill:'BH2011541',batch:'PC2154112',chassis:'DP2121201',brand:'品牌1',type:'型号',date:'2021-9-12',payType:'质损',price:'50',afterPrice:'60',},
        ],
        payTable2:[
          {number:'000000',name:'车队1',type:'日常考核',remark:'说明1',time:'2021-10-18 18:24:44',price:'20',},
          {number:'000000',name:'车队2',type:'其它',remark:'说明2',time:'2021-10-18 18:24:44',price:'20',},
        ],
      };
    },
    tableRowClassName({row}) {
      if (row.remark==='价格异常') return 'ui-warning-row';
      else return '';
    },
    handleSelectionChange(val){},
    handleSelectionChange2(val){},
    exportClick(){},
    importClick(){
      this.dialogVisible=true;
      this.dialogTitle='导入生成对账单';
      this.addData={
        title:'',
        price1:'100',
        price2:'',
        payTable:[
          {name:'委托商1',waybill:'BH2011541',batch:'PC2154112',chassis:'DP2121201',brand:'品牌1',type:'型号',date:'2021-9-12',payType:'托运',price:'60',afterPrice:'60',remark:'相等'},
          {name:'委托商1',waybill:'BH2011541',batch:'PC2154112',chassis:'DP2121201',brand:'品牌1',type:'型号',date:'2021-9-12',payType:'质损',price:'50',afterPrice:'60',remark:'价格异常'},
          {name:'委托商1',waybill:'BH2011541',batch:'PC2154112',chassis:'DP2121201',brand:'品牌1',type:'型号',date:'2021-9-12',payType:'塔电',price:'50',afterPrice:'60',remark:'相等'},
        ],
        payTable2:[
          {number:'000000',name:'车队1',type:'日常考核',remark:'说明1',time:'2021-10-18 18:24:44',price:'20',},
          {number:'000000',name:'车队2',type:'其它',remark:'说明2',time:'2021-10-18 18:24:44',price:'20',},
        ],
        carTable:[
          {name:'供应商1',batch:'PC201210112',chassis:'DP215411',brand:'品牌1',type:'型号1',priceType:'托运',price:'50',afterPrice:'50',remark:'暂未选择',},
          {name:'供应商1',batch:'PC201210112',chassis:'DP215411',brand:'品牌1',type:'型号1',priceType:'托运',price:'30',afterPrice:'30',remark:'无数据',},
          {name:'供应商1',batch:'PC201210112',chassis:'DP215411',brand:'品牌1',type:'型号1',priceType:'加油',price:'100',afterPrice:'100',remark:'无数据',},
        ],
      };
    },
    removeClick(index,val){
      if(val === 1) this.addData.payTable.splice(index,1)
      if(val === 2) this.addData.payTable2.splice(index,1)
    },
    tableAddClick(){
      this.addPriceVisible=true;
      this.priceData={
        number:'',
        name:'',
        type:'',
        time:'',
        table:[],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.nav{
  width:100%;
  height:40px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  &Container{
    width:200px;
    display: flex;
    align-items: center;
    margin-right: 5px;
    margin-bottom: 5px;
    p{
      font-size: 14px;
      color: rgba(16, 16, 16, 100);
    }
  }
  &Btn{
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }
  ::v-deep {
    label.el-form-item__label {
      font-weight: 500;
      color: #101010;
    }
  }
}
.content{
  display: flex;
  flex-direction: column;
  align-items: center;
  .tableContainer{
    margin-top: 30px;
    margin-bottom: 25px;
    width: 100%;
    ::v-deep{
      .el-checkbox{
        margin-left: 7px;
      }
    }
    &Nav{
      width:100%;
      display: flex;
      align-items: center;
      justify-content:flex-end;
      span{
        color: rgba(51, 136, 255, 1);
        text-decoration: underline;
        margin-right: 10px;
        &:hover{
          cursor: pointer;
        }
      }
    }
    ::v-deep{
      .el-table .cell {
        padding: 0;
      }
      .el-table th{
        padding: 0;
      }
      .el-table td{
        padding: 0;
      }
      .el-table th>.cell{
        font-weight: 700!important;
      }
    }
  }
  .paginationContainer{
    margin-right: auto;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    span{
      font-size: 13px;
    }
  }
}
.dialogContainer{
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 15px 10px 10px 20px;
  max-height:80vh;
  overflow: auto;
  ::v-deep{
    .el-table .ui-warning-row {
      background-color: #fef0f0!important;
    }
    .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover>td{
      background-color: #fef0f0!important;
    }
    .el-table .ui-warning-row .cell{
      color: red;
    }
    .el-table td, .el-table th{
      padding:0;
    }
    .cell{
      font-size: 10px;
      padding:0;
    }
  }
  span{
    font-size: 14px;
    color: #606266;
    font-weight: 700;
  }
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  &Title{
    display: flex;
    align-items: center;
    justify-content:space-between;
    width: 90%;
    margin-bottom: 10px;
    &Input{
      display: flex;
      align-items: center;
    }
    &Btn{
      display: flex;
      align-items: center;
    }
  }
  .instructions{
    width:100%;
    &Title{
      display:flex;
      align-items:flex-end;
      p{
        font-weight: 700;
        font-size: 14px;
        color: rgba(51, 136, 255, 1);
        margin-left: 10px;
      }
    }
    &Table{
      width:100%;
      margin-top: 10px;
      margin-bottom:10px;
      ::v-deep{
        .el-button--mini, .el-button--mini.is-round{
          padding:2px 10px;
        }
      }
      &Nav{
        width:100%;
        display: flex;
        align-items: center;
        justify-content:flex-end;
        span{
          color: rgba(51, 136, 255, 1);
          text-decoration: underline;
          margin-right: 10px;
          font-weight: 400;
          &:hover{
            cursor: pointer;
          }
        }
      }
    }
  }
}
.priceContainer{
  display: flex;
  flex-direction: column;
  padding: 15px 10px 10px 20px;
  max-height:70vh;
  overflow: auto;
  ::v-deep{
    .el-table td, .el-table th{
      padding:0;
    }
    .cell{
      font-size: 10px;
      padding:0;
    }
  }
  &Nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Item{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: #606266;
        font-weight: 700;
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      margin-left: 10px;
    }
  }
  &Table{
    margin-top: 15px;
  }
  .paginationContainer{
    margin-right: auto;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 10px;
    span{
      font-size: 13px;
    }
  }
}
</style>
